'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _themeDefinitions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var linedInput = Symbol('lined-input');
var base = Symbol('base');

var themeDefinitions = exports.themeDefinitions = (_themeDefinitions = {}, _defineProperty(_themeDefinitions, linedInput, {
    componentClass: 'lined-typeahead-input'
}), _defineProperty(_themeDefinitions, base, {}), _themeDefinitions);

var themes = exports.themes = {
    linedInput: linedInput,
    base: base
};
//# sourceMappingURL=themes.js.map